import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "madhur_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY) || "";
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const client = axios.create({ baseURL: API });

client.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

// Public
export const fetchResults = (kind, params = {}) =>
  client.get(`/results/${kind}`, { params }).then((r) => r.data);
export const fetchLatest = (kind) =>
  client.get(`/results/${kind}/latest`).then((r) => r.data);
export const fetchUpdates = () => client.get("/updates").then((r) => r.data);

// Admin
export const adminLogin = (password) =>
  client.post("/admin/login", { password }).then((r) => r.data);
export const adminVerify = () => client.get("/admin/verify").then((r) => r.data);
export const adminCreateResult = (kind, body) =>
  client.post(`/results/${kind}`, body).then((r) => r.data);
export const adminDeleteResult = (kind, id) =>
  client.delete(`/results/${kind}/${id}`).then((r) => r.data);
export const adminCreateUpdate = (body) =>
  client.post("/updates", body).then((r) => r.data);
export const adminDeleteUpdate = (id) =>
  client.delete(`/updates/${id}`).then((r) => r.data);

export default client;
